import styles from './style.module.scss';

interface Props {
    data: any[] | undefined;
};

export default function WorkExperience(props: Props) {
    const { data } = props;
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByDate = copyOfData ? copyOfData.sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime()) : null;

    return (
        <div className={styles.wrapper}>
            {data && data.length === 0 && <span>No work experience.</span>}
            {sortByDate?.map((item, indx) => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Job {indx + 1}</span>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Job title</span>
                        <span className={styles.content_main_row_val}>{item.jobTitle}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Company</span>
                        <span className={styles.content_main_row_val}>{item.company}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Location</span>
                        <span className={styles.content_main_row_val}>{item.location}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Role description</span>
                        <span className={styles.content_main_row_val}>{item.roleDescription}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Date</span>
                        <span className={styles.content_main_row_val}>{item.from} - {item.to}</span>
                    </div>
                </div>
            </div>)}
        </div>
    )
}
